export const getters = {
    loadingEvents: state => state.loadingEvents,
    loadingEvent: state => state.loadingEvent,
    errorEvents: state => state.errorEvents,
    events: state => state.events
}